module.exports = __webpack_public_path__ + "img/ch17_07_陈莹泡茶.f2dec668.jpg";